module.exports = __webpack_public_path__ + "img/2.9891f6fe.png";